import {FETCH_LOGIN_DATA} from "../../constant/ActionType";

export default function LoginnReducer(state = {
    loginData:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case FETCH_LOGIN_DATA:
			return { ...state,
				loginData: action.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}
